"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var hw_app_btc_1 = __importDefault(require("@ledgerhq/hw-app-btc"));
var logs_1 = require("@ledgerhq/logs");
var derivation_1 = require("../../derivation");
var promise_1 = require("../../promise");
var buildBigNumber_1 = require("../../libcore/buildBigNumber");
var signOperation_1 = require("../../libcore/signOperation");
var libcore_buildTransaction_1 = __importDefault(require("./libcore-buildTransaction"));
var transaction_1 = require("./transaction");
function signTransaction(_a) {
    var account = _a.account, isCancelled = _a.isCancelled, transport = _a.transport, currency = _a.currency, coreCurrency = _a.coreCurrency, transaction = _a.transaction, coreTransaction = _a.coreTransaction, derivationMode = _a.derivationMode, onDeviceStreaming = _a.onDeviceStreaming, onDeviceSignatureRequested = _a.onDeviceSignatureRequested, onDeviceSignatureGranted = _a.onDeviceSignatureGranted;
    return __awaiter(this, void 0, void 0, function () {
        var perCoin, networkParams, sigHashTypeHex, sigHashType, hasTimestamp, hwApp, additionals, expiryHeight, hasExtraData, rawInputs, inputs, associatedKeysets, outputs, changePath, outputs_1, outputs_1_1, o, output, e_1_1, outputScriptHex, initialTimestamp, _b, lockTime, unixtime, signature, sendersInput, senders, recipientsOutput, recipients, coreAmountFees, fee, txHash, operation;
        var e_1, _c;
        var _this = this;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    (0, logs_1.log)("hw", "signTransaction ".concat(currency.id, " for account ").concat(account.id));
                    perCoin = transaction_1.perCoinLogic[currency.id];
                    return [4 /*yield*/, coreCurrency.getBitcoinLikeNetworkParameters()];
                case 1:
                    networkParams = _d.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, networkParams.getSigHash()];
                case 2:
                    sigHashTypeHex = _d.sent();
                    sigHashType = parseInt(sigHashTypeHex, 16);
                    if (isNaN(sigHashType)) {
                        throw new Error("sigHashType should not be NaN");
                    }
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, networkParams.getUsesTimestampedTransaction()];
                case 3:
                    hasTimestamp = _d.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    hwApp = new hw_app_btc_1["default"](transport);
                    additionals = [currency.id];
                    if (account.derivationMode === "native_segwit") {
                        additionals.push("bech32");
                    }
                    if (perCoin === null || perCoin === void 0 ? void 0 : perCoin.getAdditionals) {
                        additionals = additionals.concat(perCoin.getAdditionals({
                            transaction: transaction
                        }));
                    }
                    expiryHeight = (perCoin === null || perCoin === void 0 ? void 0 : perCoin.hasExpiryHeight)
                        ? Buffer.from([0x00, 0x00, 0x00, 0x00])
                        : undefined;
                    hasExtraData = (perCoin === null || perCoin === void 0 ? void 0 : perCoin.hasExtraData) || false;
                    return [4 /*yield*/, coreTransaction.getInputs()];
                case 4:
                    rawInputs = _d.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, (0, promise_1.promiseAllBatched)(5, rawInputs, function (input, i) { return __awaiter(_this, void 0, void 0, function () {
                            var hexPreviousTransaction, inputHasTimestamp, previousTransaction, outputIndex, sequence;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, input.getPreviousTransaction()];
                                    case 1:
                                        hexPreviousTransaction = _a.sent();
                                        (0, logs_1.log)("libcore", "splitTransaction " + String(hexPreviousTransaction));
                                        inputHasTimestamp = (currency.id === "stealthcoin" &&
                                            hexPreviousTransaction.slice(0, 2) === "01") ||
                                            hasTimestamp;
                                        (0, logs_1.log)("hw", "splitTransaction", {
                                            hexPreviousTransaction: hexPreviousTransaction,
                                            supportsSegwit: currency.supportsSegwit,
                                            inputHasTimestamp: inputHasTimestamp,
                                            hasExtraData: hasExtraData,
                                            additionals: additionals
                                        });
                                        previousTransaction = hwApp.splitTransaction(hexPreviousTransaction, currency.supportsSegwit, inputHasTimestamp, hasExtraData, additionals);
                                        return [4 /*yield*/, input.getPreviousOutputIndex()];
                                    case 2:
                                        outputIndex = _a.sent();
                                        sequence = transaction.rbf ? 0 : 0xffffffff;
                                        (0, logs_1.log)("libcore", "inputs[" + i + "]", {
                                            previousTransaction: JSON.stringify(previousTransaction),
                                            outputIndex: outputIndex,
                                            sequence: sequence
                                        });
                                        return [2 /*return*/, [
                                                previousTransaction,
                                                outputIndex,
                                                undefined,
                                                sequence,
                                            ]];
                                }
                            });
                        }); })];
                case 5:
                    inputs = _d.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, (0, promise_1.promiseAllBatched)(5, rawInputs, function (input) { return __awaiter(_this, void 0, void 0, function () {
                            var derivationPaths, _a, first, r;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, input.getDerivationPath()];
                                    case 1:
                                        derivationPaths = _b.sent();
                                        _a = __read(derivationPaths, 1), first = _a[0];
                                        if (!first)
                                            throw new Error("unexpected empty derivationPaths");
                                        return [4 /*yield*/, first.toString()];
                                    case 2:
                                        r = _b.sent();
                                        return [2 /*return*/, r];
                                }
                            });
                        }); })];
                case 6:
                    associatedKeysets = _d.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    return [4 /*yield*/, coreTransaction.getOutputs()];
                case 7:
                    outputs = _d.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    _d.label = 8;
                case 8:
                    _d.trys.push([8, 13, 14, 15]);
                    outputs_1 = __values(outputs), outputs_1_1 = outputs_1.next();
                    _d.label = 9;
                case 9:
                    if (!!outputs_1_1.done) return [3 /*break*/, 12];
                    o = outputs_1_1.value;
                    return [4 /*yield*/, (0, transaction_1.parseBitcoinOutput)(o)];
                case 10:
                    output = _d.sent();
                    if ((0, transaction_1.isChangeOutput)(output)) {
                        changePath = output.path || undefined;
                    }
                    _d.label = 11;
                case 11:
                    outputs_1_1 = outputs_1.next();
                    return [3 /*break*/, 9];
                case 12: return [3 /*break*/, 15];
                case 13:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 15];
                case 14:
                    try {
                        if (outputs_1_1 && !outputs_1_1.done && (_c = outputs_1["return"])) _c.call(outputs_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 15: return [4 /*yield*/, coreTransaction.serializeOutputs()];
                case 16:
                    outputScriptHex = _d.sent();
                    if (isCancelled())
                        return [2 /*return*/];
                    if (!hasTimestamp) return [3 /*break*/, 18];
                    return [4 /*yield*/, coreTransaction.getTimestamp()];
                case 17:
                    _b = _d.sent();
                    return [3 /*break*/, 19];
                case 18:
                    _b = undefined;
                    _d.label = 19;
                case 19:
                    initialTimestamp = _b;
                    if (isCancelled())
                        return [2 /*return*/];
                    // Set lockTime for Komodo to enable reward claiming on UTXOs created by
                    // Ledger Live. We should only set this if the currency is Komodo and
                    // lockTime isn't already defined.
                    if (currency.id === "komodo" && lockTime === undefined) {
                        unixtime = Math.floor(Date.now() / 1000);
                        lockTime = unixtime - 777;
                    }
                    (0, logs_1.log)("hw", "createPaymentTransactionNew", {
                        associatedKeysets: associatedKeysets,
                        changePath: changePath,
                        outputScriptHex: outputScriptHex,
                        lockTime: lockTime,
                        sigHashType: sigHashType,
                        segwit: (0, derivation_1.isSegwitDerivationMode)(derivationMode),
                        initialTimestamp: initialTimestamp || undefined,
                        additionals: additionals,
                        expiryHeight: expiryHeight && expiryHeight.toString("hex")
                    });
                    return [4 /*yield*/, hwApp.createPaymentTransactionNew({
                            inputs: inputs,
                            associatedKeysets: associatedKeysets,
                            changePath: changePath,
                            outputScriptHex: outputScriptHex,
                            lockTime: lockTime,
                            sigHashType: sigHashType,
                            segwit: (0, derivation_1.isSegwitDerivationMode)(derivationMode),
                            initialTimestamp: initialTimestamp || undefined,
                            additionals: additionals,
                            expiryHeight: expiryHeight,
                            onDeviceSignatureGranted: onDeviceSignatureGranted,
                            onDeviceSignatureRequested: onDeviceSignatureRequested,
                            onDeviceStreaming: onDeviceStreaming
                        })];
                case 20:
                    signature = _d.sent();
                    return [4 /*yield*/, coreTransaction.getInputs()];
                case 21:
                    sendersInput = _d.sent();
                    return [4 /*yield*/, (0, promise_1.promiseAllBatched)(5, sendersInput, function (senderInput) {
                            return senderInput.getAddress();
                        })];
                case 22:
                    senders = (_d.sent()).filter(Boolean);
                    return [4 /*yield*/, coreTransaction.getOutputs()];
                case 23:
                    recipientsOutput = _d.sent();
                    return [4 /*yield*/, (0, promise_1.promiseAllBatched)(5, recipientsOutput, function (recipientOutput) {
                            return recipientOutput.getAddress();
                        })];
                case 24:
                    recipients = (_d.sent()).filter(Boolean);
                    return [4 /*yield*/, coreTransaction.getFees()];
                case 25:
                    coreAmountFees = _d.sent();
                    if (!coreAmountFees) {
                        throw new Error("signAndBroadcast: fees should not be undefined");
                    }
                    return [4 /*yield*/, (0, buildBigNumber_1.libcoreAmountToBigNumber)(coreAmountFees)];
                case 26:
                    fee = _d.sent();
                    txHash = "";
                    operation = {
                        id: "".concat(account.id, "-").concat(txHash, "-OUT"),
                        hash: txHash,
                        type: "OUT",
                        value: new bignumber_js_1.BigNumber(transaction.amount).plus(fee),
                        fee: fee,
                        blockHash: null,
                        blockHeight: null,
                        senders: senders,
                        recipients: recipients,
                        accountId: account.id,
                        date: new Date(),
                        extra: {}
                    };
                    return [2 /*return*/, {
                            operation: operation,
                            expirationDate: null,
                            signature: signature
                        }];
            }
        });
    });
}
exports["default"] = (0, signOperation_1.makeSignOperation)({
    buildTransaction: libcore_buildTransaction_1["default"],
    signTransaction: signTransaction
});
//# sourceMappingURL=libcore-signOperation.js.map